<template>
  <el-dialog append-to-body width="500px" :title="isChange?'编辑路线':'添加路线'" :visible.sync="visible" :before-close="reset"
    :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form class="staff-from" v-loading="loading" element-loading-text="加载中…" ref='elFormDom' label-width='110px'
      label-position='right' :model='form.data' :rules='form.rules' :size="subUnitSize">
      <el-form-item label="路线名称" prop="name">
        <el-input v-model.trim="form.data.name" placeholder="请输入" clearable></el-input>
      </el-form-item>
      <el-form-item label="配送员" prop="delivery_ids">
        <el-select v-model="form.data.delivery_ids" filterable multiple placeholder="请选择" clearable style="width:100%;">
          <el-option v-for="item in pathOpt" :key="item.id" :label="item.deliverer_name" :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <template #footer>
      <el-row type="flex" justify="end">
        <el-button @click='toggle(false)'>取消</el-button>
        <el-button type="primary" :loading="form.loading" :disabled="form.loading" @click='confirm'>确定</el-button>
      </el-row>
    </template>
  </el-dialog>
</template>

<script>
import common from '@/util'
export default {
  data() {
    return {
      subUnitSize: this.$store.state.subUnitSize, // 获取组件 size属性
      visible: false,
      isChange: false,
      loading: false,
      form: {
        loading: false,
        data: {
          id: '',
          name: "", //名称
          delivery_ids: [],
        },
        rules: {
          name: [{ required: true, message: '必填', trigger: 'change' }],
          delivery_ids: [{ required: true, message: '必填', trigger: 'change' }],
        }
      },
      pathOpt: [],
    }
  },
  methods: {
    getDetail(row) {
      this.getPath();
      if (!!row.id) {
        this.isChange = true
        this.$nextTick(() => {
          common.deepClone(this.form.data, row)
          this.form.data.delivery_ids = !!row.delivery_ids ? row.delivery_ids.split(",").map(Number) : '';
        })
      }
    },
    getPath() {
      this.$http.get('/admin/path/list', { params: { page: 1, count: 10000, } }).then(res => {
        if (res.code == 1) {
          this.pathOpt = res.data.list;
        }
      })
    },
    reset(done) {
      this.isChange = false
      this.$refs.elFormDom.resetFields()
      done && done()
    },
    toggle(show) {
      this.visible = show
      !show && this.reset()
    },
    // 提交
    confirm() {
      this.$refs.elFormDom.validate(valid => {
        if (valid) {
          let _params = {
            id: this.form.data.id,
            name: this.form.data.name,
            sort: this.form.data.sort,
            delivery_ids: !!this.form.data.delivery_ids ? this.form.data.delivery_ids.join(",") : '',
            image: this.form.data.image,
          };
          let apiUrl = '/admin/line/createOrUpdate'
          this.form.loading = true;
          this.$http.post(apiUrl, _params).then(res => {
            if (res.code === 1) {
              if(!this.isChange){
                let obj = {
                  id :res.data.id,
                  name: _params.name,
                }
                this.$emit('addCanteen', obj)
              }
              this.$emit('refresh')
              this.toggle(false);
            }
          }).finally(() => {
            this.form.loading = false;
          })
        }
      })
    },
  }
}
</script>